import { Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addTicket, updateTicket } from '../../../store/slices/ticketSlice';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddTicket({ onSwitchTab, tabProps = {} }) {
  const ticket = useSelector(state => state.ticketSlice.ticket);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [ticket]);

  const loadValues = () => {
    if (ticket.id) {
      form.setFieldsValue(ticket);
    } else {
      form.resetFields();
    }
  }

  const saveTicket = (data) => {
    if (ticket.id) {
      // dispatch(updateTicket({ ticketId: ticket.id, ticketData: data }));
    } else {
      dispatch(addTicket({ ticketData: data }));
    }
  }

  return (
    <div>
      <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{ticket.id ? ticket.name + " Says..." : "Add New ticket"}</div>
      <Form
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveTicket}
      >
        <Form.Item
          label="Ticket Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Enter ticket name here',
            },
          ]}
        >
          <Input placeholder='Name of the ticket' />
        </Form.Item>

        <Form.Item
          label="Ticket Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Enter ticket email here',
            },
          ]}
        >
          <Input placeholder='Enter ticket email here' />
        </Form.Item>

        <Form.Item
          label="Ticket Telephone"
          name="telephone"
          rules={[
            {
              required: true,
              message: 'Enter ticket telephone here',
            },
          ]}
        >
          <Input placeholder='Enter ticket telephone here' />
        </Form.Item>

        <Form.Item
          label="Message"
          name="message"
          rules={[
            {
              required: true,
              message: 'Enter ticket message here',
            },
          ]}
        >
          <Input.TextArea rows={12} placeholder='Add message here' />
        </Form.Item>

        {/* <Form.Item
          label="Status"
          name="status"
          rules={[
            {
              required: true,
              message: 'Select Status',
            },
          ]}
        > */}
          {/* <Select
            placeholder="Select Status"
          >
            <Select.Option value={'Active'}>{'Active'}</Select.Option>
            <Select.Option value={'Inactive'}>{'Inactive'}</Select.Option>
          </Select> */}
        {/* </Form.Item> */}

        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='flex justify-between'>
            {/* <div>{ticket.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div> */}
            <div className='flex'>
              {/* <Button danger type='text' htmlType='reset'>Clear</Button> */}
              <Button type='primary' disabled={ticket.id} htmlType='submit'>{ticket.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AddTicket